import { classnames } from '@aibees/shared/utils';
import { Box, Stack } from '@mui/material';
import { memo } from 'react';
import { user } from '../../mockData';
import { AccountAccordion } from '../account-accordion';
import { BillingItem } from '../billing-item';
import { InformationCard } from '../information-card';
import { InformationItem } from '../information-item';
import { allInvoices, billingAddress, billingOverview } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import type { BillingTabProps as Props } from './types';

export const BillingTab = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('BillingTab', className)}
      sx={SX.root}
    >
      <Box sx={SX.upperSection}>
        <Box sx={SX.content}>
          <InformationCard data={user} />
        </Box>
        <Box sx={SX.divider} />
        <Box sx={SX.content}>
          <InformationCard data={user} />
        </Box>
      </Box>
      <Box sx={SX.content}>
        <Stack gap={1.5}>
          <AccountAccordion title="Billing Overview" icon="credit-card-bold">
            {billingOverview.map((i) => (
              <InformationItem key={i.title} item={i} />
            ))}
          </AccountAccordion>
          <AccountAccordion title="Billing Address" icon="email-tick-outline">
            {billingAddress.map((i) => (
              <InformationItem key={i.title} item={i} />
            ))}
          </AccountAccordion>
          <AccountAccordion title="All Invoices" icon="coin">
            {allInvoices.map((i) => (
              <BillingItem key={i.price} item={i} action="VIEW" />
            ))}
          </AccountAccordion>
        </Stack>
      </Box>
    </Styled.Wrapper>
  );
});

BillingTab.displayName = 'BillingTab';
